import { SeverityLevel } from "@sentry/types";

export const SentrySeverityError = "error" as SeverityLevel;
export const SentrySeverityWarning = "warning" as SeverityLevel;
export const SentrySeverityDebug = "debug" as SeverityLevel;
